/* global window */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spin, Dropdown, Button, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import GridView from '../../../../../components/elements/GridView/index';
import * as eventsActions from '../../../../../core/events/eventsActions';
import CustomEmpty from '../../../../../components/CustomEmpty';
import { formatTimesheetReportData } from '../../../../../core/utils/reportUtils';
import { getPaginationTotal } from '../../../../../components/elements/GridView/GridViewBase/Pagination';
import { UnitOfMeasurement } from '../../../../../types/types';

class ReportTab extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            convertedReport: [],
        };
    }

    toggleUnit = () => {
        const { imperialUnit } = this.state;
        this.setState({ imperialUnit: !imperialUnit });
    };

    render() {
        const {
            timeSheetReport,
            isFetching,
            timeSheetReportPagination,
            imperialUnit,
            reportHasBeenFetched,
            companyFeatures,
            onPaginationChange,
            journeyOrDay,
        } = this.props;
        if (!reportHasBeenFetched) {
            return null;
        }

        let listReports = formatTimesheetReportData(timeSheetReport, imperialUnit, journeyOrDay, isFetching, companyFeatures);

        const exportableColumns = listReports && listReports[0]
            ? (Object.keys(listReports[0])
                .filter((oK) => oK.toLowerCase() !== 'actions'))
            : [];

        if (listReports) {
            if (listReports.length > 0) {
                return (
                    <div className="report-table">
                        <span
                            className="report-title"
                            style={{
                                left: 384,
                                top: 24,
                            }}
                        >
                            Timesheet Report
                        </span>
                        <Dropdown overlay={(
                            <Menu onClick={this.props.setUnit}>
                                <Menu.Item key={UnitOfMeasurement.BritishImperial}>Miles</Menu.Item>
                                <Menu.Item key={UnitOfMeasurement.Metric}>Kilometers</Menu.Item>
                            </Menu>
                        )}>
                            <Button
                                type="primary"
                                className="export-dropdown-button"
                                style={{
                                    right: 112,
                                    top: 16,
                                }}
                            >
                                {imperialUnit ? 'Miles' : 'Kilometers'}
                                <DownOutlined/>
                            </Button>
                        </Dropdown>
                        <Button
                            type="primary"
                            className="export-csv-button"
                            disabled={this.props.isExportingTimesheetReportCsv}
                            onClick={() => {
                                this.props.onExportCSV();
                            }}
                            style={{
                                top: '16px',
                                right: '16px',
                            }}
                        >
                            <Spin
                                size="small"
                                spinning={this.props.isExportingTimesheetReportCsv}
                            >
                                Export
                            </Spin>
                        </Button>
                        <br/>
                        <GridView
                            data={listReports}
                            onChange={this.props.onTableChange}
                            sortableColumns={['asset', 'driver', 'division', 'registration', 'start_date', 'end_date', 'shift', 'time_driven', 'idle_time', 'true_idle', 'mileage_Km', 'avg_speed_Km', 'max_speed_Km']}
                            hiddenColumns={['id', 'asset_id', 'driver_id', 'action']}
                            exportableColumns={exportableColumns}
                            pagination={{
                                total: timeSheetReportPagination.totalRecords,
                                current: timeSheetReportPagination.currentPage,
                                pageSize: timeSheetReportPagination.perPageCount,
                                showSizeChanger: false,
                                onChange: onPaginationChange,
                                showTotal: getPaginationTotal,
                            }}
                            scroll={{
                                x: 'max-content',
                                y: 'calc(100vh - 220px)',
                            }}
                        />
                    </div>
                );
            } else {
                return (<CustomEmpty/>);
            }
        } else {
            return (<></>);
        }
    }
}

ReportTab.defaultProps = {
    timeSheetReport: [],
    timeSheetReportPagination: {
        currentPage: 1,
        totalRecords: 0,
        pageCount: 0,
        perPageCount: 20,
    },
    onTableChange: () => null,
};

ReportTab.propTypes = {
    timeSheetReport: PropTypes.array,
    timeSheetReportPagination: PropTypes.object,
    isFetching: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func,
    onTableChange: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        timeSheetReport: state.report.timeSheetReport,
        timeSheetReportPagination: state.report.timeSheetReportPagination,
        isFetching: state.report.isFetching,
        isExportingTimesheetReportCsv: state.report.isExportingTimesheetReportCsv,
        companyFeatures: state.user.userCompany.features,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...eventsActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReportTab);
